/**
 * A simple hook to log the current template name in development mode
 * @param {string} templateName - The name of the template component
 */
const useTemplateDebug = (templateName) => {
  if (process.env.NODE_ENV === 'development' && templateName) {
    console.log(`template: ${templateName}`)
  }
}

export default useTemplateDebug
